import { renderInlineCssVars, useDesignTokens, useGraphTokens, } from '@sas/nova-commons/theme';
import { AddTab, ConditionalHighlightingBullet, DisclosureNext, GeoUILocationPin, GeoUIYourLocation, Hidden, Location, Search, UserSession, Visible, } from '@sas/react-svg';
import React from 'react';
import { Icon } from '@sas/nova-commons/components/Icon';
import { Flow } from '@sas/nova-commons/components/Layouts/Flow';
import { Text } from '@sas/nova-commons/components/Text';
import { Button } from '@sas/nova-commons/components/Button';
import { useI18n } from '../../../../locale/I18nContext';
import { isGeographicFeature, isGeographicRoute, isSearchHint, } from '../../../../store/objectSearch/ObjectSearchState';
import { getFeatureTokens } from '../../utils/tokens';
import cx from 'classnames';
import cn from './PanelListItem.css.json';
import './PanelListItem.css';
export const panelItemHeight = 56; // ListItem "double" height + padding
export const PanelListItem = (props) => {
    var _a;
    const dt = useDesignTokens();
    const gt = useGraphTokens();
    const localize = useI18n();
    const location = isGeographicRoute(props.item) || isSearchHint(props.item) ? '' : props.item.location;
    let description = location; // default is the item location;
    let itemIcon = undefined;
    if (isGeographicFeature(props.item)) {
        switch (props.item.type) {
            case 'route':
                description = props.item.isRendered
                    ? props.item.routeTravelDistance
                    : localize({ key: 'PinPanel.notDrawn.txt' });
                break;
            case 'area':
                description = props.item.isRendered ? location : localize({ key: 'PinPanel.notDrawn.txt' });
                break;
            case 'myLocationPin':
                itemIcon = GeoUIYourLocation;
                description = props.item.isRendered
                    ? location
                    : localize({ key: 'PinPanel.undetermined.txt' });
                break;
            default:
                itemIcon = GeoUILocationPin;
        }
    }
    else if (isSearchHint(props.item)) {
        switch (props.panelType) {
            case 'route':
                itemIcon = ConditionalHighlightingBullet;
                break;
            case 'area':
                itemIcon = AddTab;
                break;
            case 'pin':
                itemIcon = Location;
                break;
            default:
                itemIcon = props.item.isMultiple === true ? Search : Location;
        }
        description = '';
    }
    return (React.createElement(Flow, { className: cn.container, spacing: 's', orientation: "horizontal", style: renderInlineCssVars(Object.assign(Object.assign(Object.assign({}, getItemCounterTokens(dt, gt)), getDescriptionTokens(dt)), { 'colorBar-fg': isGeographicFeature(props.item)
                ? getFeatureTokens(dt, props.item).fg
                : undefined }), 'panelListItem') },
        ['area', 'route'].includes(props.item.type) && React.createElement("div", { className: cn.colorBar }),
        !props.infoOnly && !isSearchHint(props.item) && !props.searchResultMode && (React.createElement(Flow, { spacing: 'none', orientation: "vertical", className: cn.itemElement },
            React.createElement(Icon, { className: cn.iconButton, icon: props.item.hidden ? Hidden : Visible, onClick: (e) => {
                    e.stopPropagation();
                }, onPress: () => {
                    var _a;
                    (_a = props.onVisibilityButtonPress) === null || _a === void 0 ? void 0 : _a.call(props, props.item);
                }, tokens: props.item.hidden ? () => ({ fg: dt.stateStandard.disabled.fg }) : undefined }))),
        !props.infoOnly && itemIcon && (React.createElement(Flow, { spacing: 'none', orientation: "vertical", className: cn.itemElement },
            React.createElement(Icon, { onClick: (e) => {
                    e.stopPropagation();
                }, className: isSearchHint(props.item) ? cn.hintIcon : cn.iconLarge, icon: itemIcon, tokens: () => (isGeographicFeature(props.item) ? getFeatureTokens(dt, props.item) : {}) }))),
        props.counter !== undefined && (React.createElement(Flow, { spacing: 'none', orientation: "vertical", className: cn.itemElement },
            React.createElement("div", { className: cx(cn.itemCounter, cn.iconLarge), title: `(${props.counter}) ${location}` }, `${props.counter}`))),
        React.createElement(Flow, { spacing: 'xxs', orientation: "vertical", className: cn.itemText },
            React.createElement(Text, { className: cn.name, wrapText: false }, props.item.name),
            description && (React.createElement(Text, { className: cn.description, wrapText: false }, description))),
        props.item.type === 'area' && Object.keys(((_a = props.item.demographics) === null || _a === void 0 ? void 0 : _a.data) || {}).length > 0 && (React.createElement(Flow, { spacing: 'none', orientation: "vertical", className: cn.itemElement },
            React.createElement(Icon, { className: cn.iconButton, icon: UserSession, onPress: () => { var _a; return (_a = props.onShowDemographicButtonPress) === null || _a === void 0 ? void 0 : _a.call(props, props.item); } }))),
        !props.infoOnly && !isSearchHint(props.item) && !props.searchResultMode && (React.createElement(Flow, { spacing: 'none', orientation: "vertical", className: cn.itemElement },
            React.createElement(Button, { className: cn.navButton, icon: { icon: DisclosureNext, className: cn.navButtonIcon }, onPress: () => { var _a; return (_a = props.onNavigationButtonPress) === null || _a === void 0 ? void 0 : _a.call(props, props.item); }, tooltip: localize({ key: 'MainSearchPanel.navigate.tooltip.txt' }) })))));
};
function getItemCounterTokens(dt, gt) {
    switch (dt.themeVariant) {
        case 'high-contrast':
            return {
                'itemCounter-fg': '#000000',
                'itemCounter-bg': gt.graphDefault.n2,
            };
        case 'dark':
            return {
                'itemCounter-fg': gt.graphDefault.n_5,
                'itemCounter-bg': gt.graphDefault.n,
            };
        default:
            return {
                'itemCounter-fg': gt.graphDefault.white,
                'itemCounter-bg': gt.graphDefault.n_1,
            };
    }
}
function getDescriptionTokens(dt) {
    return {
        'description-fg': dt.enableNovaTokens ? dt.c.colorTextLabel : dt.text.description.fg,
    };
}
